export default class Person
{
  constructor(firstName, lastName, role, telephone, hourlyRating, notes, photoPath, password, accessCode) 
  {
    this.firstName = firstName;
    this.lastName = lastName;
    this.role = role;
    this.telephone = telephone;
    this.hourlyRating = hourlyRating;
    this.notes = notes;
    this.photoPath = photoPath;

    this.password = password;
    this.accessCode = accessCode;
  }    

  isValid()
  {
    return this.firstName && this.hourlyRating;
  }
}